import { tr as __tr, useLocale as __useLocale, direction as __direction, localizedField as __localizedField } from "../i18n/runtime";
import React, { useEffect, useRef, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import {TravelerForm} from '../components/VisaRequirements';
import { useAuth } from '../context/AuthContext';
const newKey = () => Array.from(crypto.getRandomValues(new Uint8Array(16)), n => n.toString(16).padStart(2, '0')).join('');
export default function CheckoutPage() {
  __useLocale();
  const {
    token,
    user
  } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const params = new URLSearchParams(location.search);
  const orderId = params.get('order');
  const type = params.get('type');
  const serviceId = params.get('id');
  const seatClass = params.get('seat_class') || 'economy';
  const [service, setService] = useState(null);
  const [gateways, setGateways] = useState([]);
  const [gateway, setGateway] = useState('');
  const [quantity, setQuantity] = useState(Number(params.get('quantity')) || 1);
  const [arrival, setArrival] = useState('');
  const [answers,setAnswers]=useState([]);
  const [files,setFiles]=useState({});
  const [order, setOrder] = useState(null);
  const [busy, setBusy] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const running = useRef(false);
  const pending = useRef(null);
  const headers = {
    Authorization: `Bearer ${token}`
  };
  useEffect(() => {
    const controller = new AbortController();
    setError('');
    setLoading(true);
    const options = {
      headers: {
        Authorization: `Bearer ${token}`
      },
      signal: controller.signal
    };
    (orderId ? axios.get('/api/checkout.php', {
      ...options,
      params: {
        order: orderId
      }
    }).then(r => setOrder(r.data)) : Promise.all([axios.get('/api/checkout.php', {
      ...options,
      params: {
        type,
        id: serviceId,
        seat_class: seatClass
      }
    }), axios.get('/api/commerce-config.php?kind=gateways', {
      signal: controller.signal
    })]).then(([s, g]) => {
      setService(s.data);setAnswers([]);setFiles({});
      setGateways(g.data.filter(v => v.currencies.includes(s.data.currency)));
    })).catch(e => {
      if (!controller.signal.aborted) setError(e.response?.data?.message || "تعذر تحميل الشراء");
    }).finally(() => {
      if (!controller.signal.aborted) setLoading(false);
    });
    return () => controller.abort();
  }, [orderId, type, serviceId, seatClass, token]);
  const act = async action => {
    if (running.current) return;
    running.current = true;
    setBusy(true);
    setError('');
    try {
      let payload = {
        id: orderId
      };
      if (action === 'create') {
        const people=type==='hotel'?1:Number(quantity);
        const travelers=service?.requirements?.length?Array.from({length:people},(_,i)=>answers[i]||{}):[];
        const attached=Object.entries(files).filter(([k,v])=>v&&Number(k.split('_')[1])<people);
        if(attached.length>20)throw new Error(__tr('الحد الأقصى 20 مرفقًا للطلب'));
        if(attached.some(([,f])=>f.size>2*1024*1024)||attached.reduce((n,[,f])=>n+f.size,0)>6*1024*1024)throw new Error(__tr('كل مرفق حتى 2 ميجابايت والمجموع حتى 6 ميجابايت'));
        const signature = JSON.stringify([type, serviceId, gateway, quantity, arrival, seatClass,travelers,attached.map(([k,f])=>[k,f.name,f.size,f.lastModified])]);
        if (pending.current?.signature !== signature) pending.current = {
          signature,
          key: newKey()
        };
        payload = {
          type,
          seat_class: seatClass,
          service_id: serviceId,
          gateway_id: gateway,
          quantity,
          arrival_date: arrival,
          request_key: pending.current.key, travelers, upload_keys: attached.map(([key])=>key)
        };
        if(attached.length){const data=new FormData();data.append('payload',JSON.stringify(payload));attached.forEach(([k,f])=>data.append(k,f));payload=data;}
      }
      const r = await axios.post('/api/checkout.php?action=' + action, payload, {
        headers
      });
      setOrder(r.data);
      if (action === 'create') navigate('/checkout?order=' + r.data.id, {
        replace: true
      });else if (action === 'pay' && r.data.approval_url) window.location.assign(r.data.approval_url);
    } catch (e) {
      setError(e.response?.data?.message || e.message || "تعذر تأكيد الطلب. أعد المحاولة بنفس البيانات.");
    } finally {
      running.current = false;
      setBusy(false);
    }
  };
  return <main dir={__direction()} className="max-w-2xl mx-auto p-6 space-y-5"><Link to="/" className="text-purple-700">{__tr("← الرئيسية")}</Link><h1 className="text-2xl font-bold">{__tr("شراء الخدمة")}</h1>{__tr(error && <p role="alert" className="text-red-700">{__tr(error)}</p>)}{__tr(loading && <p>{__tr("جارٍ التحميل…")}</p>)}
 {__tr(!token && <p>{__tr("يلزم ")}<Link className="underline text-purple-700" to={'/login?next=' + encodeURIComponent(location.pathname + location.search)}>{__tr("تسجيل الدخول")}</Link>{__tr(" بحساب عميل للشراء.")}</p>)}
 {__tr(token && user?.role !== 'customer' && <p>{__tr("الشراء متاح بحساب عميل. يمكنك تسجيل طلب للعميل من قائمة العمليات.")}</p>)}
 {__tr(!orderId && service && <form className="border rounded-xl p-5 space-y-4" onSubmit={e => {
      e.preventDefault();
      act('create');
    }}><h2 className="text-xl font-bold">{__tr(__localizedField(service, "name"))}</h2><p>{__tr(service.price)} {__tr(service.currency)}{__tr(type === 'hotel' ? " / ليلة" : '')}</p><label className="block">{__tr(type === 'hotel' ? "عدد الليالي لغرفة واحدة" : "عدد الأشخاص")}<input className="block border rounded p-2 w-full" required type="number" min="1" max="20" value={quantity} onChange={e => setQuantity(e.target.value)} /></label>{__tr(type === 'hotel' && <label className="block">{__tr("تاريخ الوصول")}<input type="date" required className="block border p-2" value={arrival} onChange={e => setArrival(e.target.value)} /></label>)}{['hotel','flight','bus'].includes(type)&&<p className="text-sm text-gray-600">{__tr('التفضيلات والخدمات الإضافية طلبات للمراجعة، ولا تغيّر السعر أو تؤكد التوفر تلقائيًا.')}</p>}<TravelerForm fields={service.requirements} bookingMode={type==='hotel'} quantity={type==='hotel'?1:quantity} answers={answers} files={files} onAnswer={(i,k,v)=>setAnswers(old=>{const next=[...old];next[i]={...(next[i]||{}),[k]:v};return next;})} onFile={(k,f)=>{setFiles(old=>({...old,[k]:f}));pending.current=null;}} /><p className="font-bold">{__tr("الإجمالي: ")}{__tr((Number(service.price) * Number(quantity)).toFixed(2))} {__tr(service.currency)}</p><label className="block">{__tr("طريقة الدفع")}<select required className="block border rounded p-2 w-full" value={gateway} onChange={e => setGateway(e.target.value)}><option value="">{__tr("اختر طريقة الدفع")}</option>{__tr(gateways.map(g => <option key={g.id} value={g.id}>{__tr(__localizedField(g, "name"))}{__tr(g.provider === 'paypal' && g.mode === 'sandbox' ? " (تجريبي)" : '')}</option>))}</select></label>{__tr(!gateways.length && <p>{__tr("لا توجد طريقة دفع مفعلة لهذه العملة حاليًا.")}</p>)}<p className="text-sm text-gray-600">{__tr("يُرسل الطلب إلى فريق العمليات لتنفيذ الخدمة وإرفاق مستندها. شراء الطلب لا يعني إصدار التأشيرة أو التذكرة فورًا.")}</p><button disabled={busy || !token || user?.role !== 'customer' || !gateways.length} className="bg-[#6B5B95] text-white px-5 py-2 rounded disabled:opacity-50">{__tr(busy ? "جارٍ الحفظ…" : "تأكيد طلب الشراء")}</button></form>)}
 {__tr(order && <section className="border rounded-xl p-5 space-y-4"><h2 className="font-bold">{__tr("طلب #")}{__tr(order.id.slice(0, 8))}</h2><p>{__tr(order.amount)} {__tr(order.currency)} — {__tr(__localizedField(order, 'gateway_name'))}</p>{__tr(order.status === 'cancelled' ? <p>{__tr("الطلب ملغى.")}</p> : order.status === 'paid' ? <p className="text-green-700">{__tr("تم تأكيد السداد من PayPal. تابع إنجاز الخدمة في حسابك.")}</p> : order.status === 'test_paid' ? <p>{__tr("نجحت تجربة الدفع Sandbox. لم يُسجل سداد فعلي.")}</p> : order.provider === 'paypal' ? <>{__tr(order.mode === 'sandbox' && <p className="text-amber-700">{__tr("وضع تجريبي — لا يتم تحصيل أموال فعلية.")}</p>)}{__tr(params.has('cancelled') && <p>{__tr("لم يكتمل الدفع. يمكنك المحاولة أو التحقق من نفس الطلب.")}</p>)}<button disabled={busy} className="bg-[#6B5B95] text-white px-4 py-2 rounded" onClick={() => act('pay')}>{__tr("المتابعة إلى PayPal")}</button> <button disabled={busy} className="border rounded px-4 py-2" onClick={() => act('capture')}>{__tr("تأكيد السداد بعد الموافقة في PayPal")}</button></> : <><p>{__tr("تم استلام طلبك، وهو بانتظار تأكيد السداد يدويًا.")}</p><p className="whitespace-pre-wrap">{__tr(__localizedField(order, "instructions"))}</p></>)}{__tr(order.status === 'pending' && <button disabled={busy} className="block text-red-700" onClick={() => {
        if (window.confirm(__tr("إلغاء الطلب غير المسدد؟"))) act('cancel');
      }}>{__tr("إلغاء الطلب")}</button>)}<Link className="block text-purple-700 underline" to="/dashboard">{__tr("طلباتي ومستنداتي")}</Link></section>)}
 </main>;
}
